"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubcategoriesMap = void 0;
const subcategories_1 = require("../interfaces/subcategories");
const transaction_1 = require("../interfaces/transaction");
exports.SubcategoriesMap = {
    [transaction_1.WSCategory.HomeExpenses]: subcategories_1.HomeExpensesSubcategories,
    [transaction_1.WSCategory.TravelTransport]: subcategories_1.TravelTransportSubcategories,
    [transaction_1.WSCategory.CarExpenses]: subcategories_1.CarExpensesSubcategories,
    [transaction_1.WSCategory.VehiclesMachineryEquipment]: subcategories_1.VehiclesMachineryEquipmentSubcategories,
    [transaction_1.WSCategory.OtherDeductions]: subcategories_1.PersonalDeductionsSubcategories,
    [transaction_1.WSCategory.Taxes]: subcategories_1.TaxSubcategories,
    [transaction_1.WSCategory.Transfer]: subcategories_1.TransferSubcategories,
    [transaction_1.WSCategory.Income]: subcategories_1.IncomeSubcategories
};
//# sourceMappingURL=wsCategorySubcategories.map.js.map